module.exports = __webpack_public_path__ + "static/img/scsl.a0bb4c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/AboutUs/scsl.png
// module id = KrDK
// module chunks = 12